import ActivityReport from '@/views/mypage/report/ActivityReport'
import DailyReport from '@/views/mypage/report/DailyReport'
import BsnPlan2List from '@/views/mypage/bsnPlan2/BsnPlan2List'
import SurveyList from '@/views/mypage/prtSurvey/SurveyList'
import SurveyView from '@/views/mypage/prtSurvey/SurveyView'
import MyEduInfor from '@/views/mypage/MyEduInfor'
import HeadBsnPlnList from '@/views/mypage/bsnPlan/HeadBsnPlnList'
import BsnPlnReg from '@/views/mypage/bsnPlan/BsnPlnReg'
import BsnPlnDetail from '@/views/mypage/bsnPlan/BsnPlnDetail'
import BsnPlnMemberDetail from '@/views/mypage/bsnPlan/BsnPlnMemberDetail'
import myCounselReport from '@/views/mypage/myCounselReport'


export default [
    {
        path: '/mypage/report',
        name: 'activity-report',
        component: ActivityReport,
        meta: {
            auth: true,
            logging: true, 
            pageName: '활동리포트' 
        }
    },
    {
        path: '/dailyReport',
        name: 'daily-report',
        component: DailyReport,
        meta: {
            auth: true,
            logging: true, 
            pageName: '일일리포트' 
        }
    },
    
    {
        path: '/mypage/bsnPlnList',
        name: 'bsn-pln-list',
        component: BsnPlan2List,
        meta: {
            auth: true,
            logging: true, 
            pageName: '영업활동계획 목록' 
        }
    },

    {
        path: '/mypage/headBsnPlnList',
        name: 'head-bsn-pln-list',
        component: HeadBsnPlnList,
        meta: {
            auth: true,
            logging: true, 
            pageName: '영업활동계획 목록(지국장)' 
        }
    },

    {
        path: '/mypage/bsnPlnReg',
        name: 'bsn-pln-reg',
        component: BsnPlnReg,
        meta: {
            auth: true,
            logging: true, 
            pageName: '영업활동계획 등록' 
        }
    },

    {
        path: '/mypage/bsnPlnDetail',
        name: 'bsn-pln-detail',
        component: BsnPlnDetail,
        meta: {
            auth: true,
            logging: true, 
            pageName: '영업활동계획 상세'
        }
    },
    {
        path: '/mypage/bsnPlnMemberDetail',
        name: 'bsn-pln-member-detail',
        component: BsnPlnMemberDetail,
        meta: {
            auth: true,
            logging: true, 
            pageName: '영업활동계획 상세(지국장)' 
        }
    },
    
    {
        path: '/mypage/surveyList',
        name: 'survey-list',
        component: SurveyList,
        meta: {
            auth: true,
            logging: true, 
            pageName: '설문목록' 
        }
    },
    {
        path: '/mypage/surveyView',
        name: 'survey-view',
        component: SurveyView,
        meta: {
            auth: true,
            logging: true,
            pageName: '설문상세' 
        }
    },
    {
        path: '/mypage/myEduInfor',
        name: 'my-eduinfor',
        component: MyEduInfor,
        meta: {
            auth: true,
            logging: true, // 로깅 여부
            pageName: '내교육정보', // 로깅 시 사용할 페이지명
        }
    },
    {
        path: '/mypage/myCounselReport',
        name: 'my-eduinfor',
        component: myCounselReport,
        meta: {
            auth: true,
            logging: true, // 로깅 여부
            pageName: '상담 리포트', // 로깅 시 사용할 페이지명
        }
    }
]